export const LinkedInIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="currentColor"
      className="h-6 w-6 opacity-80 transition-opacity duration-200 hover:opacity-100 lg:h-8 lg:w-8"
    >
      <path d="M29.57.08H2.43A2.59 2.59 0 0 0 0 2.35v27.38A2.36 2.36 0 0 0 2.43 32h27.14A2.59 2.59 0 0 0 32 29.73V2.35A2.36 2.36 0 0 0 29.57.08zm-20 27.14H4.85V12.06h4.7zM7.13 9.93A2.73 2.73 0 1 1 9.86 7.2a2.71 2.71 0 0 1-2.73 2.73zM22.6 27.22v-7.43c0-1.82 0-4.09-2.43-4.09s-2.88 2-2.88 3.94v7.58h-4.7V12.06h4.55v2.12a4.78 4.78 0 0 1 4.4-2.43c4.85 0 5.61 3.19 5.61 7.28l.15 8.19z"></path>
    </svg>
  );
};
